import { toast } from 'react-toastify';
import axios from 'axios';
import * as types from '../constants/actionTypes';
import { request } from '../helpers/axiosRequest';
import { logUserActivity } from './activityLogsActions';

export const API = axios.create({ baseURL: process.env.REACT_APP_API_URL });

// Create Blog
export const addBlog = (data, navigate, setLoading) => async (dispatch) => {
  try {
    dispatch({ type: types.CREATE_BLOG_ATTEMPT });
    const res = await request({
      url: `${process.env.REACT_APP_API_URL}/blogs/create-post`,
      auth: true,
      method: 'POST',
      data
    });
    setLoading(false);
    toast.success(res.data?.message ? res.data?.message : 'Blog Added Successsully');
    dispatch({
      type: types.CREATE_BLOG_SUCCESS,
      payload: { ...data }
    });
    dispatch(logUserActivity(`ADDED_BLOG`));
    setTimeout(() => {
      navigate('/dashboard/blogs');
    }, 2000);
  } catch (err) {
    setLoading(false);
    dispatch({ type: types.CREATE_BLOG_FAIL, payload: err });
    toast.error(
      err.response?.data?.message ? err.response.data.message : 'Error: Unable to add blog'
    );
    throw err;
  }
};

// Get All Featured Blogs
export const allFeaturedBlogs = (id) => async (dispatch) => {
  dispatch({ type: types.GET_ALL_BLOGS_ATTEMPT });
  try {
    const res = await request({
      url: `${process.env.REACT_APP_API_URL}/blogs/get-featured`,
      auth: true,
      method: 'GET'
    });

    dispatch({
      type: types.GET_ALL_BLOGS_SUCCESS,
      payload: res.data
    });
  } catch (err) {
    dispatch({ type: types.GET_ALL_BLOGS_FAIL, payload: err });
    throw err;
  }
};

// Get All Active Blogs
export const allActiveBlogs = (id) => async (dispatch) => {
  dispatch({ type: types.ALL_ACTIVE_BLOGS_ATTEMPT });
  try {
    const res = await request({
      url: `${process.env.REACT_APP_API_URL}/blogs/get-all`,
      auth: true,
      method: 'GET'
    });

    dispatch({
      type: types.ALL_ACTIVE_BLOGS_SUCCESS,
      payload: res.data
    });
  } catch (err) {
    dispatch({ type: types.ALL_ACTIVE_BLOGS_FAIL, payload: err });
    throw err;
  }
};

// Get Single Blog
export const singleBlog = (data) => async (dispatch) => {
  dispatch({ type: types.SINGLE_BLOG_ATTEMPT });
  try {
    const res = await request({
      url: `${process.env.REACT_APP_API_URL}/blogs/get-by-id`,
      auth: true,
      method: 'POST',
      data
    });
    dispatch({
      type: types.SINGLE_BLOG_SUCCESS,
      payload: res.data.blog
    });
  } catch (err) {
    dispatch({ type: types.SINGLE_BLOG_FAIL, payload: err });
    throw err;
  }
};

// Update Blog
export const updateBlog = (data, navigate, setLoading) => async (dispatch) => {
  try {
    dispatch({ type: types.UPDATE_BLOG_ATTEMPT });
    const res = await request({
      url: `${process.env.REACT_APP_API_URL}/blogs/update-by-id`,
      auth: true,
      method: 'PUT',
      data
    });
    setLoading(false);
    dispatch({
      type: types.UPDATE_BLOG_SUCCESS,
      payload: { ...data }
    });
    toast.success(res.data?.message ? res.data.message : 'Blog Updated Successsully');
    dispatch(logUserActivity(`UPDATED_BLOG`));
    setTimeout(() => {
      navigate('/dashboard/blogs');
    }, 2000);
  } catch (err) {
    setLoading(false);
    dispatch({ type: types.UPDATE_BLOG_FAIL, payload: err });
    throw err;
  }
};

// Delete Blog
export const deleteBlog = (id) => async (dispatch) => {
  try {
    dispatch({ type: types.DELETE_BLOG_ATTEMPT });
    const res = await request({
      method: 'POST',
      auth: true,
      url: `${process.env.REACT_APP_API_URL}/blogs/delete-by-id`,
      data: { _id: id }
    });

    toast.success('Blog Deleted Successsully', {
      position: 'top-center',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      draggable: true,
      progress: undefined
    });
    dispatch(logUserActivity(`DELETED_BLOG`));
    setTimeout(() => {
      window.location.href = '/dashboard/blogs';
    }, 1000);
    dispatch({ type: types.DELETE_BLOG_SUCCESS, payload: {} });
  } catch (err) {
    dispatch({ type: types.DELETE_BLOG_FAIL, payload: err });
    throw new Error(err);
  }
};

// Blog Categories
// Create Blog
export const addBlogCategories = (data, navigate) => async (dispatch) => {
  try {
    dispatch({ type: types.CREATE_BLOG_CATEGORY_ATTEMPT });
    const res = await request({
      url: `${process.env.REACT_APP_API_URL}/blogs-category/add-category`,
      auth: true,
      method: 'POST',
      data
    });
    toast.success('Category Added Successsully', {
      position: 'top-center',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      draggable: true,
      progress: undefined
    });
    dispatch({
      type: types.CREATE_BLOG_CATEGORY_SUCCESS,
      payload: { ...data }
    });
    dispatch(logUserActivity(`ADDED_BLOG_CATEGORY`));
    setTimeout(() => {
      navigate('/dashboard/blogs-category');
    }, 2000);
  } catch (err) {
    dispatch({ type: types.CREATE_BLOG_CATEGORY_FAIL, payload: err });
    toast.error('Error: Unable to add blog', {
      position: 'top-center',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      draggable: true,
      progress: undefined
    });
    throw err;
  }
};

// Get Single Blog
export const singleBlogCategory = (id) => async (dispatch) => {
  dispatch({ type: types.SINGLE_BLOG_CATEGORY_ATTEMPT });
  try {
    const res = await request({
      url: `${process.env.REACT_APP_API_URL}/blogs-category/get-by-id/${id}`,
      auth: true,
      method: 'GET'
    });
    dispatch({
      type: types.SINGLE_BLOG_CATEGORY_SUCCESS,
      payload: res.data
    });
  } catch (err) {
    dispatch({ type: types.SINGLE_BLOG_CATEGORY_FAIL, payload: err });
    throw err;
  }
};

// Update Blog
export const updateBlogCategory = (data, navigate) => async (dispatch) => {
  try {
    dispatch({ type: types.UPDATE_BLOG_CATEGORY_ATTEMPT });
    const res = await request({
      url: `${process.env.REACT_APP_API_URL}/blogs-category/update-by-id`,
      auth: true,
      method: 'PUT',
      data
    });
    toast.success('Category Updated Successsully', {
      position: 'top-center',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      draggable: true,
      progress: undefined
    });
    dispatch({
      type: types.UPDATE_BLOG_CATEGORY_SUCCESS,
      payload: { ...data }
    });
    dispatch(logUserActivity(`UPDATED_BLOG_CATEGORY`));
    setTimeout(() => {
      navigate('/dashboard/blogs-category');
    }, 2000);
  } catch (err) {
    dispatch({ type: types.UPDATE_BLOG_CATEGORY_FAIL, payload: err });
    throw err;
  }
};

// Delete Blog Category
export const deleteBlogCategory = (id) => async (dispatch) => {
  try {
    dispatch({ type: types.DELETE_BLOG_CATEGORY_ATTEMPT });
    const res = await request({
      method: 'POST',
      auth: true,
      url: `${process.env.REACT_APP_API_URL}/blogs-category/delete-by-id`,
      data: { _id: id }
    });

    toast.success('Category Deleted Successsully', {
      position: 'top-center',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      draggable: true,
      progress: undefined
    });
    dispatch(logUserActivity(`DELETED_BLOG_CATEGORY`));
    setTimeout(() => {
      window.location.href = '/dashboard/blogs-category';
    }, 1000);
    dispatch({ type: types.DELETE_BLOG_CATEGORY_SUCCESS, payload: {} });
  } catch (err) {
    dispatch({ type: types.DELETE_BLOG_CATEGORY_FAIL, payload: err });
    throw new Error(err);
  }
};
